<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">{{ label }}</div>
    </el-col>
    <el-col :span="spanSetting">
      <div class="value-area">{{ value }}</div>
    </el-col>
    <el-col :span="spanSuffix">
      <div class="suffix-area">{{ suffix }}</div>
    </el-col>
  </el-row>
</template>

<script>
import Constants from './Constants'

export default {
  name: 'NumberView',
  props: {
    label: {
      type: String
    },
    value: {
      type: Number
    },
    suffix: {
      type: String
    },
    spanTitle: {
      type: Number,
      default: Constants.SPAN_TITLE
    },
    spanSetting: {
      type: Number,
      default: Constants.SPAN_INPUT
    },
    spanSuffix: {
      type: Number,
      default: Constants.SPAN_SUFFIX
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 5px;
  margin-right: 10px;
}
div.value-area {
  text-align: end;
  font-weight: bold;
  font-size: large;
  margin-right: 10px;
  margin-top: 5px;

  color: #0044FF
}
div.suffix-area {
  text-align: left;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
  color: #0044FF
}
</style>
